<template>
    <vx-box-glass class="text-slate-700 font-sans">
        <vx-wallpaper :icon="faListUl"></vx-wallpaper>
        <div class="relative p-6 xl:p-10 max-w-2xl">
            <h2 class="mb-2 text-xl font-bold">Overview</h2>
            <p class="text-sm mb-3 font-sans text-slate-700 lg:text-base">
                Create rules to governing what content can be sent out in campaign messages.
            </p>
            <a
                href="https://support.voxie.com"
                target="_blank"
                rel="noopener noreferrer"
                class="text-sm font-sans font-normal text-sky-500 underline lg:text-base"
            >
                See Docs for More
                <font-awesome-icon widthAuto class="ml-2g" :icon="faArrowRightLong"></font-awesome-icon>
            </a>
        </div>
    </vx-box-glass>
</template>

<script setup lang="ts">
import { VxBoxGlass, VxWallpaper } from '@voxie/frontend-components';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faArrowRightLong, faListUl } from '@fortawesome/pro-solid-svg-icons';
</script>
